/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import Swal from "sweetalert2"
import { CircularProgress } from "@material-ui/core"

import NewStatus from "./NewStatus"

import { translate } from "../../../translate/i18n"

import { putRequest } from "utils/request"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { useModal } from "hooks/modal"
import { getRequest } from "utils/request"
import exportExcel from "utils/exportExcel"
import format from "date-fns/format"

export default function TabStatus({ companyData, handleUpdate }) {
  const [status, setStatus] = useState([])
  const [loading, setLoading] = useState(true)
  const [onlyActive, setOnlyActive] = useState(true)
  const [newstatus, setNewStatus] = useState(false)
  const [selectedstatus, setSelectedStatus] = useState({})
  const [globalFilter, setGlobalFilter] = useState("")
  const { toggleHelperId } = useModal()

  const getStatus = () => {
    getRequest(
      `/companiesstatus/?CompanyId=${companyData.id}&onlyActive=${
        onlyActive ? 1 : 0
      }`
    ).then((resp) => {
      console.log("resp", resp)
      resp.data.forEach((e) => {
        if (e.active === true) {
          e.active = translate("userActive")
        } else {
          e.active = translate("inactive")
        }
      })
      setStatus(resp.data)
      setLoading(false)
    })
  }

  const handleGoBack = () => {
    setNewStatus(!newstatus)
  }

  const handleNewStatus = () => {
    handleUpdate(5)
    setNewStatus(!newstatus)
  }

  const handleEditStatus = (data) => {
    setSelectedStatus(data)
    setNewStatus(!newstatus)
  }

  const handleNew = () => {
    setSelectedStatus({})
    setNewStatus(true)
  }

  const header = (
    <div className="data-table-header">
      <div
        className="checkbox-container"
        style={{ position: "absolute", left: 0 }}
      >
        <input
          checked={onlyActive}
          onChange={() => setOnlyActive(!onlyActive)}
          type="checkbox"
          className="checkbox"
          style={{ marginRight: 10 }}
        />
        <label>{translate("showInactive")}</label>
      </div>
      <i className="pi pi-search" style={{ paddingRight: 10 }}></i>
      <input
        className="input-globalfilter"
        type="search"
        onChange={(e) => setGlobalFilter(e.target.value)}
        placeholder="Buscar"
        icon="pi pi-search"
      />
    </div>
  )

  const actionButtonsTemplate = (data) => {
    return (
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div
          className="action-icon"
          style={{ cursor: "pointer", marginRight: 10 }}
          onClick={() => handleEditStatus(data)}
        >
          <i className="mdi mdi-pencil" style={{ fontSize: 20 }}></i>
        </div>
        {!data.onlyUser && (
          <div
            className="action-icon"
            style={{ cursor: "pointer" }}
            onClick={() => handleInativate(data.id)}
          >
            <i className="mdi mdi-delete" style={{ fontSize: 20 }}></i>
          </div>
        )}
      </div>
    )
  }

  const handleInativate = (id) => {
    Swal.fire({
      title: translate("attemption"),
      text: translate("deleteStatus"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: translate("confirmEraseCompany"),
    }).then((result) => {
      if (result.isConfirmed) {
        putRequest(`/companiesstatus/inactivate/${id}`).then(function (
          response
        ) {
          handleUpdate(5)
        })
      }
    })
  }

  useEffect(() => {
    getStatus()
    setGlobalFilter("")
  }, [onlyActive])

  useEffect(() => {
    toggleHelperId(!newstatus ? 40 : 41)
  }, [newstatus])

  const handleExport = () => {
    let data = []

    status.forEach((e) => {
      const statusAux = {
        Id: e.id,
        Status: e.statusUserDescription,
        [translate("externalDescription")]: e.externalDescription,
        [translate("internalDescription")]: e.internalDescription,
        [translate("createdAt")]: format(new Date(e.createdAt), "dd/MM/yyyy"),
      }

      data.push(statusAux)
    })

    exportExcel(data, translate("status"))
  }

  return (
    <div className="list-container">
      <div
        className="title-helper-container"
        style={{ borderWidth: !newstatus && 0 }}
      >
        <h3>{companyData.nickName}</h3>
        {!newstatus && (
          <button
            style={{ marginBottom: 5 }}
            type="button"
            onClick={handleExport}
            className="export-excel"
          >
            <i
              style={{ fontSize: 16, marginRight: 5 }}
              className="pi pi-file-excel"
            />
            <span style={{ fontSize: "1vw" }}>
              {translate("exportAllData")}
            </span>
          </button>
        )}
      </div>
      {!newstatus ? (
        <>
          {!loading ? (
            <div className="tab-content">
              <div
                className="tab-pane show active"
                id="basic-datatable-preview"
              >
                <DataTable
                  header={header}
                  globalFilter={globalFilter}
                  dataKey="id"
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  value={status}
                  paginator
                  rows={5}
                  emptyMessage={translate("noStatusFinded")}
                >
                  <Column
                    field="statusUserDescription"
                    header={translate("status")}
                    sortable
                  ></Column>
                  <Column
                    field="internalDescription"
                    header={translate("externalDescription")}
                    sortable
                  ></Column>
                  <Column
                    field="externalDescription"
                    header={translate("internalDescription")}
                    sortable
                  ></Column>
                  <Column
                    field="active"
                    header={translate("status")}
                    sortable
                  ></Column>
                  <Column
                    body={actionButtonsTemplate}
                    field="action"
                    header={translate("action")}
                  ></Column>
                </DataTable>
              </div>
            </div>
          ) : (
            <div className="area-loading">
              <CircularProgress />
            </div>
          )}

          <div className="button-add-relative" onClick={() => handleNew()}>
            <i className="mdi mdi-plus"></i>
          </div>
        </>
      ) : (
        <NewStatus
          handleNewStatus={handleNewStatus}
          companyId={companyData.id}
          selectedstatus={selectedstatus}
          handleGoBack={handleGoBack}
        />
      )}
    </div>
  )
}
